import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import { fetchApi } from "../../utlis/axios";
import { toast } from "react-toastify";
import { FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import Pagination from '../../ListingPage/Pagination'

export const FamilyDonation = () => {
  const [familyData, setFamilyData] = useState([]);
  const { access } = useSelector(state => state.authSlice.userInfo);
  const { id } = useSelector(state => state.authSlice.userInfo?.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [modal, setModal] = useState(false);
  const [program, setProgram] = useState();
  const [family, setFamily] = useState();
  const [formValues, setFormValues] = useState({ 
    type: 'education',
    reason: '',
    amount: '',
    family: [], 
    program: '', 
  });
  const [validationErrors, setValidationErrors] = useState({
    type: "",
    reason: "",
    amount: "",
    program: "",
  });

  const navigate = useNavigate();

  const getFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`donation/?search=${searchQuery}`, {
        headers: {
          'Authorization': `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setFamilyData(result?.data);
        console.log('result data', result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  const getPrograms = async () => {
    try {
      const result = await fetchApi.get('family-programs/', {
        headers: {
          Authorization: `Bearer ${access}`
        }
      });
      if (result?.status === 200) {
        setProgram(result?.data);
        console.log("program result...//", result?.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const getFamily = async () => {
    try {
      const result = await fetchApi.get('family/?status=accepted&limit=1000', {
        headers: {
          Authorization: `Bearer ${access}`
        }
      });
      if (result?.status === 200) {
        setFamily(result?.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {
      type: "",
      reason: "",
      amount: "",
      program: "",
    };

    if (!formValues.type) {
      valid = false;
      errors.type = "Type is required";
    }

    if (!formValues.reason) {
      valid = false;
      errors.reason = "Reason is required";
    }

    if (!formValues.amount) {
      valid = false;
      errors.amount = "Amount is required";
    }

    if (!formValues.program) {
      valid = false;
      errors.program = "Program is required";
    }

    setValidationErrors(errors);
    return valid;
  };

  useEffect(() => {
    getPrograms();
    getFamily();
  }, []);

  useEffect(() => {
    getFamilyData();
  }, [searchQuery, access]);

  const handleTableRowClick = (id) => {
    console.log("id :", id);
  };

  const toggle = () => {
    setModal(!modal);
    setFormValues({
      type: 'education',
      reason: '',
      amount: '',
      family: [],
      program: '',
    });
  };

  const createDonation = async () => {
    console.log("clicked");
    if (!validateForm()) {
      return;
    }
    try {
      const data = new FormData();
      data.append('id', id);
      data.append('type', formValues?.type);
      data.append('reason', formValues?.reason);
      data.append('amount', formValues?.amount);
      data.append('program', formValues?.program);
      data.append('is_active', true);
      if (formValues.family.length > 0) {
        formValues.family.forEach((familyId, index) => {
          data.append('family', [familyId]);
        });
      }
      
      const result = await fetchApi.post('donation/', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 201) {
        console.log("posted donation");
        setModal(false);
        toast.success("Donation created successfully!");
      }
      getFamilyData();
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(familyData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;
    
    try {
      const result = await fetchApi.get(
        `donation/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setFamilyData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const nextPageData = async () => {
    const nextPage = currentPage + 1;
    const newOffset = (nextPage - 1) * itemsPerPage;
  
    setIsLoading(true);
  
    try {
      const result = await fetchApi.get(
        `donation/?limit=${itemsPerPage}&offset=${newOffset}&page=${nextPage}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
  
      if (result.status === 200) {
        setFamilyData(result?.data);
        setCurrentPage(nextPage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const prevPageData = async () => {
    const prevPage = currentPage - 1;
    const newOffset = (prevPage - 1) * itemsPerPage;
  
    setIsLoading(true);
  
    try {
      const result = await fetchApi.get(
        `donation/?limit=${itemsPerPage}&offset=${newOffset}&page=${prevPage}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );
  
      if (result.status === 200) {
        setFamilyData(result?.data);
        setCurrentPage(prevPage);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <div className="w-full px-[16px] md:px-10 min-h-screen mt-16 max-w-screen-xl mx-auto">
      {/* Top Section */}
      <h1 className="md:text-4xl text-2xl font-bold capitalize mb-4">
        Family Donations
      </h1>
      <div className="flex items-center justify-between gap-3 mt-6 md:mb-4 mb-[13px]">
        {/* Search */}
        <div className="relative flex justify-center border rounded-full sm:py-2 py-1 px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
          <FaSearch className="text-gray-500" />
          <input
            type="search"
            name="search"
            className="w-full outline-none text-gray-600 sm:py-2 py-[4px] px-1 bg-transparent"
            placeholder="Search here...."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Add Donation Button */}
        <div className="Tbtn">
          <span
            className="primary-button sm:text-base text-sm font-medium"
            onClick={toggle}
          >
            Create Donation
          </span>
        </div>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-primary-green text-white text-left">
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Family
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap text-center">
                Program
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap text-center">
                Family Status
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap text-center">
                Budget
              </th>
              <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                Reason
              </th>
              
            </tr>
          </thead>

          <tbody className="">
            {isLoading ? (
              <tr>
                <td colSpan={5} className="h-[60vh]">
                  <div className="flex justify-center items-center h-full w-full">
                    <Lottie
                      loop={true}
                      animationData={Loader}
                      style={{ width: "200px" }}
                      className="auth-sidebar-video"
                    />
                  </div>
                </td>
              </tr>
            ) : familyData?.results?.length > 0 ? (
              familyData?.results?.map((data, index) => (
                <tr
                  key={index}
                  className={`cursor-pointer ${
                    index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                  } hover:bg-gray-200`}
                  onClick={() => handleTableRowClick(data?.id)}
                >
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.family?.name}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate text-center">
                    {data?.program?.name ? data?.program?.name :'Ramadan'}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate text-center capitalize">
                      {data?.family?.status}
                 
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate text-center">
                    {data?.program?.budget}
                  </td>
                  <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                    {data?.reason}
                  </td>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="p-4 text-center">
                  No donations found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
       <div className="flex justify-center items-center mt-6">
        <Pagination
          currentPage={currentPage}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
        />
      </div>
      {modal &&
      <div className="fixed inset-0 z-[100] flex justify-center ">
        {/* backdrop */}
        <div
          className="absolute inset-0 bg-black/50"
          onClick={toggle}
        ></div>

        {/* modal wrapper */}
        <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
          <div className="relative z-[200] w-full max-w-lg my-auto">
            <div className="bg-[#FCFBF7] rounded-3xl shadow-xl">
              {/* Close button */}
              <button
                className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer text-black  hover:text-gray-700 text-2xl"
                onClick={toggle}
              >
                <IoMdClose />
              </button>

              {/* Header */}
              <div className="sm:px-6 px-[12px]">
              <div className=" pt-6 pb-4 border-b border-[#444444] w-full">
                <h2 className="md:text-3xl text-2xl font-bold text-gray-800">
                  Donation For Family
                </h2>
              </div>
              </div>
            <div className=" pt-4  sm:px-6 px-[16px]">
              <form>
              <div className="form-group">
  <label htmlFor="type" className="col-form-label">
    Type:
  </label>
  <div className="relative">
    <select
      id="type"
      name="type"
      className="form-control appearance-none pr-8"
      value={formValues?.type}
      onChange={(e) => setFormValues({ ...formValues, type: e.target.value })}
      style={{
        borderRadius: "10px",
        height: "3rem",
        background: "white",
        border: "1px solid #444444",
      }}
      required
    >
      <option value="education">Education</option>
      <option value="health">Health</option>
      <option value="food">Food</option>
      <option value="business">Business</option>
      <option value="other">Other</option>
    </select>
    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
      </svg>
    </div>
  </div>
  <span className="error-message text-danger text-sm">
    {validationErrors.type}
  </span>
</div>

                <div className="form-group">
                  <label htmlFor="reason" className="col-form-label">
                    Reason:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="reason"
                    style={{
                      borderRadius: "10px",
                      height: "3rem",
                      background: "white",
                      border: "1px solid #444444",
                    }}
                    value={formValues?.reason}
                    onChange={(e) => setFormValues({ ...formValues, reason: e.target.value })}
                    required
                  />
                  <span className="error-message text-danger text-sm">
                    {validationErrors.reason}
                  </span>
                </div>

                <div className="form-group">
                  <label htmlFor="amount" className="col-form-label">
                    Amount:
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="amount"
                    style={{
                      borderRadius: "10px",
                      height: "3rem",
                      background: "white",
                      border: "1px solid #444444",
                    }}
                    value={formValues?.amount}
                    onChange={(e) => setFormValues({ ...formValues, amount: e.target.value })}
                    required
                  />
                  <span className="error-message text-danger text-sm">
                    {validationErrors.amount}
                  </span>
                </div>

                <div className="form-group">
                  <label htmlFor="program" className="col-form-label">
                    Program:
                  </label>
                  <div className="relative">
                  <select
                    id="program"
                    name="program"
                    className="form-control"
                    value={formValues?.program}
                    onChange={(e) => setFormValues({ ...formValues, program: e.target.value })}
                    style={{
                      borderRadius: "10px",
                      height: "3rem",
                      background: "white",
                      border: "1px solid #444444",
                    }}
                    required
                  >
                    <option value="">Select Program</option>
                    {program?.results?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.program?.name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
      </svg>
    </div>
    </div>
                  <span className="error-message text-danger text-sm">
                    {validationErrors.program}
                  </span>
                </div>

                <div className="form-group">
                  <label htmlFor="family" className="col-form-label">
                    Family:
                  </label>
                  <select
                    id="family"
                    name="family"
                    className="form-control"
                    value={formValues?.family}
                    onChange={(e) => setFormValues({ 
                      ...formValues, 
                      family: Array.from(e.target.selectedOptions, option => option.value) 
                    })}
                    style={{
                      borderRadius: "10px",
                      background: "white",
                      border: "1px solid #444444",
                      minHeight: "100px",
                    }}
                    required
                    multiple
                  >
                    {family?.results?.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                  <span className="error-message text-danger text-sm">
                    {validationErrors.family}
                  </span>
                </div>
              </form>
            </div>
          <div className="pt-2 border-none" style={{ border: "none !important", padding: "16px 24px" }}>
            <div className="flex w-full justify-start gap-3">
              <button
                onClick={createDonation}
                className="font-quicksand primary-button px-6"
              >
                Create Donation
              </button>
            </div>
          </div>
        </div>
        </div>
        </div>
      </div>
}
    </div>
  );
};